import africanCulturesExpanded from "@/backend/lib/data/africanCulturesExpanded.json";

type CultureData = {
  culture: string;
  alternate_names?: string[];
  wikipedia_url?: string | null;
};

const culturesData = africanCulturesExpanded as CultureData[];

/**
 * Map of culture name (lowercased, trimmed) or alternate name to the full culture data object.
 * Keys map to CultureData; includes both primary names and alternate names.
 */
export const cultureNameToData: Record<string, CultureData> = (() => {
  const map: Record<string, CultureData> = {};
  for (const culture of culturesData) {
    if (culture.culture) {
      map[culture.culture.toLowerCase().trim()] = culture;
    }
    if (culture.alternate_names && Array.isArray(culture.alternate_names)) {
      for (const alt of culture.alternate_names) {
        map[alt.toLowerCase().trim()] = culture;
      }
    }
  }
  return map;
})();


export function getCultureWikipediaUrl(
  cultureName: string | undefined,
): string | null {
  if (!cultureName) return null;

  const normalizedInput = cultureName.toLowerCase().trim();

  for (const culture of culturesData) {
    if (culture.culture.toLowerCase() === normalizedInput) {
      return culture.wikipedia_url || null;
    }
    if (
      culture.alternate_names?.some(
        (alt) => alt.toLowerCase() === normalizedInput,
      )
    ) {
      return culture.wikipedia_url || null;
    }
  }

  for (const culture of culturesData) {
    if (culture.culture.toLowerCase().includes(normalizedInput)) {
      return culture.wikipedia_url || null;
    }
    if (normalizedInput.includes(culture.culture.toLowerCase())) {
      return culture.wikipedia_url || null;
    }
    if (
      culture.alternate_names?.some(
        (alt) =>
          alt.toLowerCase().includes(normalizedInput) ||
          normalizedInput.includes(alt.toLowerCase()),
      )
    ) {
      return culture.wikipedia_url || null;
    }
  }

  return null;
}
